var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"narrow-title-underline accent mt-4",class:_vm.color})
}
var staticRenderFns = []

export { render, staticRenderFns }